import React from "react";

import Text from 'components/Text';
import Modal from 'components/Modal';
import ModalForm from 'components/ModalForm';
import Title from "components/Title"
import { withRouter } from "react-router";
import styles from "./AmwayPopup.module.css";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;

const AmwayPopup = (props) => {
    const { isVisible } = props;
    const redirectToAmway = "/lite";
    const handleSubmit = (e) => {
        e.preventDefault()
        if(isMobile) {
            const googlePlay =  /Android|Mobile|BlackBerry|webOS|IOpera Mini|EMobile/i.test(
              navigator.userAgent
            );

            const appStore = /iPhone|iPod/i.test(
              navigator.userAgent
            );

            if(googlePlay || appStore) {
                window.location.assign(appStore ? 'https://apps.apple.com/ru/app/nutrilogic-lite/id1611164559' : 'https://play.google.com/store/apps/details?id=nutrilogic.lite');
            }
        }
        else {
            props.router.push(redirectToAmway)
        }
    }
    return <Modal
      ariaHideApp={false}
      isOpen={isVisible}
      customOverlayClass={'modal--amWay'}
      customContainerClass={'content--amWay'}
    >
        <ModalForm
          submitBtn='Да'
          cancelBtn='Нет'
          onSubmit={handleSubmit}
          valid={true}
          onCancel={props.handleHide}
          noPadding
          isAmway
        >
            <div className={cx("body")}>
                <div className={cx("left-part")}>
                    <Title size='medium' isAmway>
                        Вы являетесь независимым предпринимателем Amway?
                    </Title>
                    <div className={cx("description")}>
                        <Text>
                            Мы предлагаем Вам специальную версию нашего сервиса
                        </Text>
                    </div>

                </div>
                <img alt='' src="http://go.nutrilogic.ru/static/media/amway_welcome.jpg" className={cx("right")} />
            </div>
        </ModalForm>
    </Modal>
}

export default withRouter(AmwayPopup);